import './NewAppointmentButton.scss';

import { useDispatch } from 'react-redux';

import Button from 'atoms/button';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { openDrawer } from 'store/reducers/ui';

export default function NewAppointmentButton({
  data,
  variant = 'white-outlined',
}) {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const openNewAppointmentDrawer = () => {
    dispatch(openDrawer({ type: 'new-appointment', data }));
  };

  return (
    <Button
      className="new-appointment-button f14 fw-400"
      text={isMobile ? 'Appointment' : 'New appointment'}
      size="small"
      variant={variant}
      icon="add"
      iconPosition="start"
      iconProps={variant === 'default' ? { style: { fill: '#fff' } } : {}}
      onClick={openNewAppointmentDrawer}
    />
  );
}
